
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 6301"}},[_c('g',{attrs:{"data-name":"Group 7823","fill":"none","stroke":"#109a50"}},[_c('g',{attrs:{"data-name":"Ellipse 375"}},[_c('circle',{attrs:{"cx":"25","cy":"25","r":"25","stroke":"none"}}),_c('circle',{attrs:{"cx":"25","cy":"25","r":"24.5"}})]),_c('g',{attrs:{"data-name":"Group 26","stroke-width":"1.064"}},[_c('path',{attrs:{"data-name":"Path 18","d":"M24.667 34.643l-9.294-9.642 9.294-9.643"}}),_c('path',{attrs:{"data-name":"Line 7","d":"M16 25.001h18"}})])])])])
          )
        }
      }
    